import withEntity from '@/entity/components/with-entity';
import AuditTrail from './audit-trail';

export default withEntity(AuditTrail);
